export default __webpack_public_path__ + "static/media/Adam.60fe6c31.png";